export abstract class ZiggeoPlayerConfig {
  public ziggeoToken: string;
}

export const ziggeoPlayerRootProviders = (options: ZiggeoPlayerConfig) => [
  { provide: ZiggeoPlayerConfig, useValue: options },
];
